import React, { useEffect, useState } from "react"
import { Button, Checkbox, message as messager, Modal } from "antd"
import { CheckboxChangeEvent } from "antd/es/checkbox"
import { CheckboxValueType } from "antd/es/checkbox/Group"

import { GetAuditFormSelectList, GetAuditRollback } from "../../../../../../services/dct/DctService"

import clsName from './index.module.scss'

interface RevokeModalProps {
  subjectCode: string
  onClose: (reload: boolean)=> void
}
const RevokeModal: React.FC<RevokeModalProps> = ({ subjectCode, onClose })=> {

  const [revokeOptions, setRevokeOptions] = useState<{label: string, value: string}[]>([])

  // 拒绝
  const [formIdList, setFormIdList] = useState<string[]>([])
  const [indeterminate, setIndeterminate] = useState(false)
  const [checkAll, setCheckAll] = useState(false)

  const handleChangeAll = ({ target }: CheckboxChangeEvent)=> {
    setFormIdList(target.checked ? revokeOptions.map(({ value })=> value) : [])
    setIndeterminate(false)
    setCheckAll(target.checked)
  }

  const handleChange = (value: CheckboxValueType[])=> {
    setFormIdList(value as string[])
    setIndeterminate(value.length > 0 && value.length < revokeOptions.length)
    setCheckAll(value.length === revokeOptions.length)
  }

  const handleConfirm = async ()=> {

    if (formIdList.length === 0) {
      messager.error('请选择撤销表单')
      return
    }

    const { code, message } = await GetAuditRollback({
      subjectCode,
      formIdList,
      cancelType: 2
    })

    if (code === 0) {
      messager.success(message)
      onClose(true)
    }
  }

  const fetchData = async()=> {
    const { data = [] } = await GetAuditFormSelectList({ subjectCode })

    setRevokeOptions(data.map(({ formName, formId }: {formId: string, formName: string})=> ({
      label: formName,
      value: formId,
    })))
  }

  useEffect(()=> {
    fetchData()
  }, [])

  return (
    <Modal
      open
      title="请选择撤销表单"
      onOk={handleConfirm}
      onCancel={()=> onClose(false)}
      className={clsName.modal}
      width={980}
      footer={
        <div className={clsName.footer}>
          <div>
            <Checkbox indeterminate={indeterminate} onChange={handleChangeAll} checked={checkAll}>全选</Checkbox>
          </div>
          <div>
            <Button type="primary" onClick={handleConfirm}>确定</Button>
            <Button onClick={()=> onClose(false)}>取消</Button>
          </div>
        </div>
      }
    >
      <Checkbox.Group
        value={formIdList}
        options={revokeOptions}
        style={{display: 'grid', gap: '6px', gridTemplateColumns: 'repeat(3, 1fr)'}}
        onChange={handleChange}
      />
  </Modal>
  )
}

export default RevokeModal
